//tas保险相关
import request from '../../utils/request'

//保险列表接口
export function insuranceList(data) {
    return request({
        url: '/setting/insurance/getPage',
        method: 'post',
        data,
    })
}

//保险列表接口--总部
export function getHeadQuartersPage(data) {
    return request({
        url: '/setting/insurance/getHeadQuartersPage',
        method: 'post',
        data,
    })
}

// 总计
export function getPageCount(data) {
    return request({
        url: '/setting/insurance/getPageCount',
        method: 'post',
        data,
    })
}

//保险列表接口--总部
export function getHeadQuartersPageCount(data) {
    return request({
        url: '/setting/insurance/getHeadQuartersPageCount',
        method: 'post',
        data,
    })
}


//投保
export function retryInsurance(query) {
    return request({
        url: '/setting/insurance/applyByRecordCode',
        method: 'get',
        params: query,
    })
}


//退保

export function cancelInsurance(query) {
    return request({
        url: '/setting/insurance/cancelByRecordCode',
        method: 'get',
        params: query,
    })
}

// 获取保险产品列表
export function getInsuranceProduct(type=false,query) {
    let url;
    if(type==true){//旅游卫士
        url = '/external/insurance/getSimpleList'
    }else{//安游保、江泰产品列表
        url = '/setting/insurance/org/getSimpleList'
    }
    return request({
        url: url,
        method: 'get',
        params: query,
    })
    
}

//tas 入驻设置 运营设置 保险设置
// TAS-查询保险-运营设置提示状态
export function getWarnStatus() {
    return request({
        url: '/setting/insurance/warn/getWarnList',
        method: 'get',
    })
}

//获取
export function getInsuranceListInSetting(query) {
    return request({
        url: '/setting/insurance/org/getPage',
        method: 'post',
        data:{
            ...query,
            productIdList:query.productIdList || [],
            businessTypeList:query.businessTypeList ? query.businessTypeList.split(',') : []
        } 
    })
}

//修改保险类型
export function updateInsuranceInfos(data) {
    return request({
        url: '/setting/insurance/org/updateInfos',
        method: 'post',
        data
    })
}

//保险赠送 
//获取列表

export function getGiftInsuranceList() {
    return request({
        url: '/setting/eshop/free/insurance/getList',
        method: 'get',
    })
}


//绑定保险
export function saveBatchInsuraance(data) {
    return request({
        url: '/setting/eshop/free/insurance/saveBatch',
        method: 'post',
        data
    })
}


//DAS 保险

//获取
export function getInsuranceListInDasSetting(query) {
    return request({
        url: '/external/insurance/getDasPage',
        method: 'get',
        params: query,
    })
}

//修改保险类型
export function updateDasInsuranceInfos(data) {
    return request({
        url: '/external/insurance/updateInfos',
        method: 'post',
        data
    })
}


//其它赠送项目列表
export function getGiftList(){
    return request({
        url: '/setting/eshop/free/other/getPage',
        method: 'get',
    })
}

//查询历史记录分页
export function getGiftHistoryList(params){
    return request({
        url: `/setting/eshop/free/other/getRecordPage/${params.freeCode}`,
        method: 'get',
        // params
    })
}

//新增 修改
export function saveGift(data){
    return request({
        url: '/setting/eshop/free/other/saveOne',
        method: 'post',
        data
    })
}

//删除
export function delGift(freeCode){
    return request({
        url: `/setting/eshop/free/other/deleteOne/${freeCode}`,
        method: 'delete',
    })
}
//保险赠送的过滤

//供应商名称的模糊搜索
export function getSrmByKeyword(data){
    return request({
        url: 'signing/eshop/srm/supplier/getSrmByKeyword',
        method: 'get',
        params: data,
    })
}

//供应商名称的模糊搜索 产品上用
export function getSrmByKeywordFilter(data){
    return request({
        url: 'signing/eshop/srm/supplier/getSrmByKeywordFilter',
        method: 'get',
        params: data,
    })
}

//产品名称的模糊搜索（productCode）
export function getProductByKeyword(data){
    return request({
        url: 'product/eshop/srm/product/getProductByKeyword',
        method: 'post',
        data,
    })
}
// 保险赠送的过滤 的 删除
export function deleteFilter(filterCode){
    return request({
        url: `/setting/eshop/insurance/filter/deleteOne/${filterCode}`,
        method: 'delete',
    })
}

// 保险赠送的过滤 的 查询分页
export function getFilterPage(data){
    return request({
        url: `/setting/eshop/insurance/filter/getPage`,
        method: 'get',
        params: data,
    })
}
// 保险赠送的过滤 的  新增修改
export function saveFilter(data){
    return request({
        url: '/setting/eshop/insurance/filter/saveOne',
        method: 'post',
        data
    })
}


//根据供应商code获取业务+区域信息
export function getSrmAreaList(data){
    return request({
        url: 'signing/eshop/srm/supplierBusinessArea/getSrmAreaList',
        method: 'get',
        params: data,
    })
}

//获取该产品是否赠送保险
export function getProductInsurance(data){
    return request({
        url: `/setting/eshop/free/insurance/getOne/`,
        method: 'get',
        params:data
    })
}

//验证游客是否可以投保,且投保保费的计算
export function checkApply(data){
    return request({
        url: `/setting/insurance/checkApply`,
        method: 'post',
        data
    })
}

export function getSettingStatus(){
    return request({
        url:'/setting/eshop/insurance/getSettingStatus',
        method: 'get',
    })
}

//安游保 保单下载地址
export function anYBaoOrderQuery(data){
    return request({
        url: `/setting/insurance/anYBaoOrderQuery/${data}`,
        method: 'post',
    })
}


//保险产品列表接口 远行家
export function getDasProductList(data) {
    return request({
        url: '/external/insurance/yxj/getDasProductList',
        method: 'post',
        data,
    })
}

//保险产品详情接口 远行家
export function getDasProductDetail(data) {
    return request({
        url: '/external/insurance/yxj/getDasProductDetail',
        method: 'post',
        data,
    })
}



// WEBPACK FOOTER //
// ./src/TASMini/api/insurance.js